import { memo } from 'react';

export type ModalSectionHeaderProps = {
  label: string;
};

export const ModalSectionHeader = memo(({ label }: ModalSectionHeaderProps) => (
  <div className="font-bold text-10 text-grey-10 uppercase tracking-[0.4px]">{label}</div>
));

ModalSectionHeader.displayName = 'ModalSectionHeader';
